import type { IPost } from "../../../../types/models/post.models.types";
import { usePostHttp } from "../../http.hook";

interface IBody {
  campaignId: string;
  liveUrl: string;
  fixedPayoutAmount: number | undefined;
  userId: string | undefined
}

interface IResponse {
  post: IPost;
}

export function useCreatePostAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/posts",
  });
}
